import React, { useEffect, useRef } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { HighlightOutlined } from '@ant-design/icons';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';
import BeautifyControl from '../../../../Shared/BeautifyControl/BeautifyControl';


const { TextArea } = Input;

const FooterInput = ({
    message,
    setMessage,
    handleKeyDown,
    updateSelectionFromEvent,
    isRecording,
    pendingVoice,
    textAreaRef,
    focusInputRef,
    mobileButtonStyle,
    beautifying,
    runBeautifyMessage,
    iconSize
}) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    // Expose a focus method to parent via ref
    useEffect(() => {
        if (!focusInputRef || typeof focusInputRef !== 'object') return;
        focusInputRef.current = () => {
            try {
                const input = textAreaRef.current?.resizableTextArea?.textArea || textAreaRef.current?.input || textAreaRef.current;
                if (input && typeof input.focus === 'function') {
                    input.focus();
                }
            } catch (e) { }
        };
        return () => { focusInputRef.current = null; };
    }, [focusInputRef, textAreaRef]);


    const tt = (key, fallback) => {
        const value = t(key);
        return value === key ? fallback : value;
    };

    const hasText = !!(message && message.trim());

    if (isRecording || pendingVoice) return null;

    return (
        <>
            {hasText && (
                <BeautifyControl
                    value={message}
                    onChange={setMessage}
                    runBeautify={runBeautifyMessage}
                    beautifyLabel={tt('beautify', 'Beautify')}
                    revertLabel={tt('revert', 'Revert')}
                    size="middle"
                    disabled={!hasText || beautifying}
                    beautifyIcon={<HighlightOutlined style={{ fontSize: iconSize }} />}
                    revertIcon={<HighlightOutlined style={{ fontSize: iconSize }} />}
                    buttonStyle={{ ...mobileButtonStyle, color: '#7F56D9' }}
                    showMeta={false}
                />
            )}

            <TextArea
                ref={textAreaRef}
                value={message}
                onChange={(e) => { setMessage(e.target.value); updateSelectionFromEvent(e); }}
                onSelect={updateSelectionFromEvent}
                onClick={updateSelectionFromEvent}
                onKeyUp={updateSelectionFromEvent}
                onKeyDown={handleKeyDown}
                placeholder={t('start_a_message')}
                rows={1}
                autoSize={message ? { minRows: 1, maxRows: 3 } : false}
                style={{
                    flex: 1,
                    border: 'none',
                    resize: 'none',
                    padding: '8px 0',
                    fontSize: '15px',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    color: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : undefined
                }}
            />
        </>
    );
};

export default FooterInput;
